export default {
  name: 'Header',
  props: {
    title: String
  }
};
